import {
  BaseUrlStoreAction,
  BaseUrlStoreKind,
  BaseUrlStoreType,
  possibleBaseUrls,
} from './baseUrlStore.types';

export const INITIAL_BASE_URL = possibleBaseUrls[0];

const BaseUrlStore = (
  state: BaseUrlStoreType,
  action: BaseUrlStoreAction
): BaseUrlStoreType => {
  switch (action.type) {
    case BaseUrlStoreKind.INITIAL: {
      return { ...state, ...action.payload };
    }
    default:
      throw new Error();
  }
};

export default BaseUrlStore;
